import { displayNotification, sendAPIRequest } from "helpers";
import { ELEMENT_GROUP_COLUMN_SIZES_MAPPINGS } from "modules/pvs_activities/constants";
import React, { useContext, useEffect, useState } from "react";
import GroupColumn from "./GroupColumn";
import { FormDataContext } from "../contexts/FormContext";

const GroupElement = (props) => {
    const formDataContext = useContext(FormDataContext);

    const [columns, setColumns] = useState([]);
    const [elements, setElements] = useState([]);

    useEffect(() => {
        loadColumns();
    }, []);

    useEffect(() => {
        columns.length > 0 && loadElements();
    }, [columns]);

    const loadColumns = async () => {
        try {
            const req = await sendAPIRequest(`/api/pvsa/template-group-columns?group-id=${props.id}`);
            const ret = await req.json();
            if (ret.success) {
                setColumns(ret.data);
            } else {
                displayNotification("error", "Error loading group columns [B]");
            }
        } catch (e) {
            console.error({ e });
            displayNotification("error", "Error loading group columns [F]");
        }
    };

    const loadElements = async () => {
        try {
            const params = new URLSearchParams();
            params.append("sub-section-id", props.element.sub_section_id);
            params.append("group-id", props.id);
            params.append("group-column-id", columns.map(r => r.id).join(','));
            const req = await sendAPIRequest(`/api/pvsa/template-sub-section-elements?${params.toString()}`);
            const ret = await req.json();
            if (ret.success) {
                setElements(ret.data);
                if (formDataContext.mode === "preview") {
                    const tmp = {};
                    for (const x of ret.data) {
                        tmp[x.id] = { id: x.id, content: "" };
                    }
                    formDataContext.setElementsData(existing => ({...existing, ...tmp}));
                }
            } else {
                displayNotification("error", "Error loading group column elements [B]");
            }
        } catch (e) {
            console.error({ e });
            displayNotification("error", "Error loading group column elements [F]");
        }
    };

    const getColSize = (size) => {
        return ELEMENT_GROUP_COLUMN_SIZES_MAPPINGS[size] ?? "100";
    };

    return (
        <div className="row">
            {columns.map((c) => (
                <div key={c.id} className={`col-md-${getColSize(c.size)} col-sm-${getColSize(c.size)} col-12`}>
                    <GroupColumn
                        id={c.id}
                        size={c.size}
                        templateId={props.templateId}
                        sectionId={props.element.sub_section_id}
                        groupId={props.id}
                        elements={elements.filter(r => String(r.group_column_id) === String(c.id))}
                        isReadOnly={props.isReadOnly}
                    />
                </div>
            ))}
        </div>
    );
};

GroupElement.defaultProps = {
    templateId: "",
    id: "",
    element: {},
    isReadOnly: false,
};

export default GroupElement;
